import React from 'react'
import "./About.css"
import HeroSection from '../Home/HeroSection';

const About = () => {
  return (
    <HeroSection name={"Quick E-commerce"}/>
  )
}

export default About;